
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import { usePostListUiActions } from '@/composables/ui/uiActions'
import useTopic from '@/composables/topic/topic'
import TopLoginBanner from '@/components/Post/TopLoginBanner.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import useAppState from '@/composables/ui/ui'
import PostTopNewestList from '@/components/Post/PostTopNewestList.vue'
import usePostsLoader from '@/composables/post/postLoader'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: 'PostSimpleList',
  components: {
    AButton,
    PostTopNewestList,
    TechnicalShutdown,
    TopLoginBanner,
    ALoader,
  },
  setup() {
    return {
      ...useTopic(),
      ...usePostListUiActions(),
      ...useAppState(),
      ...usePostsLoader(),
      ...useRouter(),
    }
  },
})
